import React from 'react';
import ReportDetails from '../ReportDetails';
import {
  EXTERNAL_ACTIVE_USERS_DESCRIPTION,
  EXTERNAL_ACTIVE_USERS_DESCRIPTION_FOR_MIXED_PLAN
} from '../../utils/resources/reports';

const defaultProps = {
  title: 'External Active Users',
  subtitle: 'last month',
  description: EXTERNAL_ACTIVE_USERS_DESCRIPTION,
  descriptionForMixedPlan: EXTERNAL_ACTIVE_USERS_DESCRIPTION_FOR_MIXED_PLAN,
  tabs: [
    {
      title: 'Active Users',
      selector: 'externalActiveUsersByMonth',
      csvFilename: 'externalActiveUsersByMonth',
      csvDescription:
        'This table shows monthly external active users for the past 12 months of the subscription.',
      csvColumns: {
        month: 'Month',
        users_external: 'External Active Users'
      },
      headers: [
        {
          title: 'Month'
        },
        {
          title: 'Active Users'
        }
      ],
      columns: [
        {
          keyName: 'month'
        },
        {
          keyName: 'users_external'
        }
      ]
    },
    {
      title: 'Active Users by Tenant',
      selector: 'externalActiveUsersByTenantMonth',
      csvFilename: 'externalActiveUsersByTenant',
      csvDescription:
        'This table shows monthly external active users for each tenant for the past 12 months of the subscription.',
      csvColumns: {
        month: 'Month',
        tenant: 'Tenant',
        users_external: 'External Active Users'
      },
      headers: [
        {
          title: 'Month'
        },
        {
          title: 'Tenant',
          keyName: 'tenant',
          isFilter: true
        },
        {
          title: 'Active Users'
        }
      ],
      columns: [
        {
          keyName: 'month'
        },
        {
          keyName: 'tenant',
          isTooltip: true
        },
        {
          keyName: 'users_external'
        }
      ]
    }
  ],
  applianceTabs: [
    {
      title: 'Active Users',
      selector: 'externalActiveUsersByMonth',
      csvFilename: 'externalActiveApplianceUsersByMonth',
      csvDescription:
        'This table shows monthly external active users for the past 12 months of the subscription.',
      csvColumns: {
        month: 'Month',
        users_external: 'External Active Users'
      },
      headers: [
        {
          title: 'Month'
        },
        {
          title: 'Active Users'
        }
      ],
      columns: [
        {
          keyName: 'month'
        },
        {
          keyName: 'users_external'
        }
      ]
    },
    {
      title: 'Active Users by Private Instance',
      selector: 'externalActiveUsersByApplianceMonth',
      csvFilename: 'externalActiveApplianceUsersByAppliance',
      csvDescription:
        'This table shows monthly external active users for each appliance for the past 12 months of the subscription.',
      csvColumns: {
        month: 'Month',
        environment: 'Environment',
        root_domain_auth: 'Private Instance',
        users_external: 'External Active Users'
      },
      headers: [
        {
          title: 'Month'
        },
        {
          title: 'Environment',
          keyName: 'environment',
          isFilter: true
        },
        {
          title: 'Private Instance',
          keyName: 'root_domain_auth',
          isFilter: true
        },
        {
          title: 'Active Users'
        }
      ],
      columns: [
        {
          keyName: 'month'
        },
        {
          keyName: 'environment',
          isTooltip: true
        },
        {
          keyName: 'root_domain_auth',
          isTooltip: true
        },
        {
          keyName: 'users_external'
        }
      ]
    },
    {
      title: 'Active Users by Tenant',
      selector: 'externalActiveUsersByAppplianceByTenantMonth',
      csvFilename: 'externalActiveApplianceUsersByTenant',
      csvDescription:
        'This table shows monthly external active users for each tenant for the past 12 months of the subscription.',
      csvColumns: {
        month: 'Month',
        environment: 'Environment',
        root_domain_auth: 'Private Instance',
        tenant: 'Tenant',
        users_external: 'External Active Users'
      },
      headers: [
        {
          title: 'Month'
        },
        {
          title: 'Environment',
          keyName: 'environment',
          isFilter: true
        },
        {
          title: 'Private Instance',
          keyName: 'root_domain_auth',
          isFilter: true
        },
        {
          title: 'Tenant',
          keyName: 'tenant',
          isFilter: true
        },
        {
          title: 'Active Users'
        }
      ],
      columns: [
        {
          keyName: 'month'
        },
        {
          keyName: 'environment',
          isTooltip: true
        },
        {
          keyName: 'root_domain_auth',
          isTooltip: true
        },
        {
          keyName: 'tenant',
          isTooltip: true
        },
        {
          keyName: 'users_external'
        }
      ]
    }
  ]
};

export default function ReportDetailsExternalUsers(props) {
  return (<ReportDetails {...defaultProps} {...props} />);
}
